import { motion } from 'framer-motion'
import { useState } from 'react'
import { cn } from '~utils/cn'

const PageEntrance = ({ children }: { children: React.ReactNode }) => {
  const [isTransitioning, setIsTransitioning] = useState(false)

  return (
    <motion.div
      className={cn('w-full h-dynamic-screen', isTransitioning && 'overflow-hidden')}
      initial={{ opacity: 0.3, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0.3, x: -100 }}
      onAnimationStart={() => {
        setIsTransitioning(true)
      }}
      onAnimationComplete={() => {
        setIsTransitioning(false)
      }}
      transition={{
        type: 'spring',
        stiffness: 260,
        damping: 20,
        duration: 0.5,
      }}
    >
      {children}
    </motion.div>
  )
}

export default PageEntrance
